export const environment = {
  production: true,
  apiUrl: "https://apisf.freshdelivery.pro/api/v1/",
  apiUrl1: "https://apisf.freshdelivery.pro",
  imageUrl: '',
  vendorImageUrl: '',
  badgesImageUrl: '',
  categoryImageUrl: '',
  sideNavProfileImage: '',
  nodeApi: "https://websocket.farmdelivery.software/api/",
  googleMapApi : "AIzaSyAyh7VLAHW3FoD8F2ZZ-Ph1JltSWwSDd54",
  /** Development Purposes Only */
  websiteUrl: '',
  RX_URL_SCHEMA : "https",
  RX_BASE_DEV_SITE: '',
  serverRequestUrl : '',
  RX_CDN_URL: "https://dkwmk0jjbz4cb.cloudfront.net",

  trackjsToken : "a05515622b084788a28db67029228a9f",
  sourcemapKey : "247b5fa8417742a6aa0dfdd6312df39d"
};
